module.exports = __webpack_public_path__ + "img/vapor.842b065a.png";